import { makeAutoObservable, runInAction } from 'mobx';

import { cmApi, customRequest } from '@src/api';
import { downloadAsFile, getFileName } from '@utils';
import type { CmApi, ReportUserAuditDto } from '@src/api';

import { preloaderStore } from '../preloaderStore';

export class UserRoleReportStore {
  userAudit: ReportUserAuditDto = {};

  api: CmApi;

  constructor({ api }: { api: CmApi }) {
    this.api = api;
    makeAutoObservable(this);
  }

  getReportUserAudit = async (): Promise<void> => {
    preloaderStore.preloader(true);
    try {
      const { data } = await this.api.admin.getReportUserAudit();

      if (data) {
        runInAction(() => {
          this.userAudit = data;
        });
      }
    } catch (error) {
      console.error(error);
    }
    preloaderStore.preloader(false);
  };

  getExcel = async (): Promise<void> => {
    preloaderStore.preloader(true);
    try {
      const response = await customRequest({
        path: `/excel/users/audit/download`,
        method: 'GET',
      });
      const contentDisposition = response.headers.get('Content-Disposition');
      const fileName = contentDisposition ? getFileName(contentDisposition) : null;

      downloadAsFile(await response.blob(), fileName ?? 'Список пользователей и ролей.xlsx');
    } catch (error) {
      console.error(error);
    }
    preloaderStore.preloader(false);
  };
}

export const userRoleReportStore = new UserRoleReportStore({ api: cmApi });
